const LOAD_DETAIL_INTERVIEW_JOBS           = 'LOAD_DETAIL_INTERVIEW_JOBS'
const LOAD_DETAIL_INTERVIEW_JOBS_SUCCESS   = 'LOAD_DETAIL_INTERVIEW_JOBS_SUCCESS'
const LOAD_DETAIL_INTERVIEW_JOBS_FAILED    = 'LOAD_DETAIL_INTERVIEW_JOBS_FAILED'
const UNMOUNT_DETAIL_INTERVIEW_JOBS        = 'UNMOUNT_DETAIL_INTERVIEW_JOBS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobsDetailInterviewReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_INTERVIEW_JOBS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_INTERVIEW_JOBS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_INTERVIEW_JOBS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_INTERVIEW_JOBS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobsDetailInterviewReducer;